jQuery(document).ready(function ($) {

  var hpBanner = new Splide('.banner', {
    type: 'fade',
    perPage: 1,
    cover: true,
    arrows: false,
    pagination: false,
    autoHeight: true,
    heightRatio: true,
    gap: 0,
    autoplay: true,
    interval: 5000,
    rewind: true,
    // breakpoints: {
    //   768: {
    //     perPage: 1,
    //     pagination: true
    //   },
    //   1024: {
    //     perPage: 2,
    //     pagination: true
    //   },
    // },
    classes: {
      pagination: 'splide__pagination dots hp-splide__pagination', // container
      arrows: 'splide__arrows hp-splide__arrows',
      arrow: 'splide__arrow hp-splide__arrow',
      prev: 'splide__arrow--prev hp-splide__arrow--prev',
      next: 'splide__arrow--next hp-splide__arrow--next',
      page: 'splide__pagination__page hp-splide__pagination__page',
    },
  });
  hpBanner.mount();

  //Offset Homepage Banner if global nav items are present when using Transparent Nav.
  if ($(window).width() > 1024) {
    if ($('.transparent-nav .global-nav.desktop .global-nav__links li').length >= 1) {
      console.log("Global nav is present.");
      $('.global-nav.desktop ').height(function (index, height) {
        $('.banner').css("margin-top", height);
        console.log("Added" + " " + height + "px margin-top to banner");
      });
    }
  }

  //Offset Header if Alerts are present when using Transparent Nav.
  // if ($(window).width() > 1024) {
  //   if ($('.transparent-nav .alerts').length >= 1) {
  //     console.log("Alerts is present.");
  //     $('.alerts').height(function (index, height) {
  //       $('.header').css("margin-top", height);
  //       console.log("Added" + " " + height + "px margin-top to banner");
  //     });
  //   }
  // }

  //Homepage video banner
  if ($('.banner__video.show').length) {
    //Remove flex-wrap container
    $('.banner__video.show iframe').unwrap();
    $('.banner__video.show iframe').attr('tabindex', '-1');
  }

  //Remove homepage video banner on mobile
  $(document).ready(function () {
    // Check window size on page load
    if ($(window).width() < 1024) {
      $('.banner__video').remove();
    }
  });

  //Testimonials Splide
  //Allow multiple splides of the same class
  var elms = document.getElementsByClassName('hp__testimonials');
  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i]).mount();
  }

  //Initiate Testimonials splides
  document.addEventListener('DOMContentLoaded', function () {
    var hpTestimonials = new Splide('.hp__testimonials', {
      type: 'fade',
      perPage: 1,
      perMove: 1,
      gap: 50,
      arrows: false
    });
    hpTestimonials.mount();
  });
  //End Testimonials Splide

  var featuredPosts = new Splide('.hp__recent-posts', {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: 50,
    arrows: false,
    breakpoints: {
      768: {
        perPage: 1,
        pagination: true
      },
      1024: {
        perPage: 2,
        pagination: true
      },
    },
  });
  featuredPosts.mount();

});